import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { MockDataService } from './MockDataService';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  private mockDataService = inject(MockDataService);

  API_PATH = null;

  constructor() {
    const environment = inject<any>('environment' as any);

    this.API_PATH = environment.api_path;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      req.url.includes(this.API_PATH) ||
      req.url.includes(this.API_PATH.replace('/api', ''))
    ) {
      const url = req.url
        .replace(this.API_PATH, '')
        .replace(this.API_PATH.replace('/api', ''), '');
      return this.mockDataService.getMockResponse(url).pipe(
        switchMap((mockResponse) => {
          if (mockResponse) {
            return of(new HttpResponse({ status: 200, body: mockResponse }));
          } else {
            return next.handle(req);
          }
        }),
      );
    } else {
      return next.handle(req);
    }
  }
}
